import { createI18n } from 'vue-i18n'
import zhCN from './zh-CN'
import enUS from './en-US'

export type AppLocale = 'zh-CN' | 'en-US'

export const SUPPORTED_LOCALES: { value: AppLocale; label: string }[] = [
  { value: 'zh-CN', label: '简体中文' },
  { value: 'en-US', label: 'English' },
]

const stored = localStorage.getItem('wordapp-app')
let initialLocale: AppLocale = 'zh-CN'
try {
  if (stored) {
    const parsed: unknown = JSON.parse(stored)
    if (parsed && typeof parsed === 'object' && 'language' in parsed) {
      const lang = (parsed as { language?: unknown }).language
      if (lang === 'zh-CN' || lang === 'en-US') initialLocale = lang
    }
  }
} catch {
  initialLocale = 'zh-CN'
}

const i18n = createI18n({
  legacy: false,
  locale: initialLocale,
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
  },
})

/** 非组件环境使用（路由守卫等） */
export function translate(key: string, params?: Record<string, unknown>): string {
  return i18n.global.t(key, params ?? {})
}

export default i18n
